import script from "./DownloadPayDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadPayDialog.vue?vue&type=script&setup=true&lang=js"

import "./DownloadPayDialog.vue?vue&type=style&index=0&id=e00a231e&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/MathQuestionBank/quesbank_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e00a231e"]])

export default __exports__